"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeRenewalDeclineWordingWidget = void 0;
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var React = require("react");
var HomeRenewalDeclineText_1 = require("./HomeRenewalDeclineText");
var commonFunctions_1 = require("../../commonFunctions");
var HomeRenewalDeclineWordingWidget = /** @class */ (function (_super) {
    __extends(HomeRenewalDeclineWordingWidget, _super);
    function HomeRenewalDeclineWordingWidget(props) {
        return _super.call(this, props) || this;
    }
    HomeRenewalDeclineWordingWidget.prototype.render = function () {
        var address = this.props.interaction.policyHolder.address;
        return (React.createElement("div", { className: "font-weight-bold" },
            React.createElement(HomeRenewalDeclineText_1.HomeRenewalDeclineText, { underwritingResult: this.props.interaction.underwritingResult, customerAddress: React.createElement(React.Fragment, null,
                    address.addressLine1,
                    ", ... ",
                    address.postcode) }),
            React.createElement("p", null,
                "You\u2019ll need to make alternative insurance arrangements as your home policy will end on ",
                (0, commonFunctions_1.formatDateTime)(this.props.interaction.headerInfo.endDate),
                ". Until then, you are still covered."),
            React.createElement("p", null,
                "Our friends at Gallagher may be able to help you find the cover you need. Call them about their specialist insurance on ",
                React.createElement("a", { className: "text-decoration-underline text-blue-1", href: "tel:+44 333 188 7823", "aria-label": "Phone number +44 333 188 7823" }, "0333 188 7823"),
                "."),
            React.createElement("p", null,
                "Or visit ",
                React.createElement("a", { className: "text-decoration-underline text-blue-1", href: "https://www.biba.org.uk/", target: "_blank" }, "BIBA.org.uk"),
                ' ',
                "to look for another suitable provider.")));
    };
    return HomeRenewalDeclineWordingWidget;
}(plugin_journey_1.WidgetBase));
exports.HomeRenewalDeclineWordingWidget = HomeRenewalDeclineWordingWidget;
//# sourceMappingURL=HomeRenewalDeclineWordingWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/declineTextOutputWidget/HomeRenewalDeclineWordingWidget.js
// module id = 3716
// module chunks = 0